var React = require('react');

function Shape (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M203.884 626.298C218.011 753.516 44.042 799.665 -24.2795 818.655L-183.031 41.4278C130.82 -31.658 768.327 -158.393 807.548 -80.6468C856.573 16.536 679.165 182.97 456.134 252.172C193.522 333.654 178.988 402.101 203.884 626.298Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"-1.99999","y1":"-4.00001","x2":"306","y2":"560","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#F2F6FF","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#F2F6FF","stopOpacity":"0","key":1})]))]);
}

Shape.defaultProps = {"width":"901","height":"827","viewBox":"0 0 901 827","fill":"none"};

module.exports = Shape;

Shape.default = Shape;
